"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const AddCard = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_99_1537)"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M16.813 9.75V5.845a1.969 1.969 0 00-1.97-1.969H4.157a1.969 1.969 0 00-1.968 1.969v7.312c0 1.088.88 1.969 1.968 1.969H11",
  stroke: "#ACB3BE",
  strokeWidth: 1.324,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M2.188 7.25h14.624M5 11.047h1.688v.703H5v-.703z",
  stroke: "#ACB3BE",
  strokeWidth: 1.588,
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5 11a.5.5 0 00-.5.5v2h-2a.5.5 0 000 1h2v2a.5.5 0 001 0v-2h2a.5.5 0 100-1h-2v-2a.5.5 0 00-.5-.5z",
  fill: "#ACB3BE"
})));

var _default = AddCard;
exports.default = _default;